<template>
  <page logoHref="/admin/orders" class="home-page">
    <loader :isLoaderOn="loaderOn"></loader>
    <div class="container">
      <b-modal
        ref="userModel"
        title="Attention Required!"
        hide-footer
        no-close-on-backdrop
      >
        <div class="row">
          <div class="col-12">
            By refreshing this order it will create new application for this order. are
            you sure to do this ?
          </div>
        </div>
        <hr />
        <div class="col col-6">
          <button class="btn btn-primary" @click="onConfirmRefresh()">Refresh</button>
          <button class="btn btn-outline-secondary" @click="closeRefreshDialog()">
            Close
          </button>
        </div>
      </b-modal>

      <b-modal
        ref="f9645Modal"
        title="Form 9465 Submission"
        hide-footer
        no-close-on-backdrop
      >
        <div class="row">
          <div class="col-12">
            Please confirm you want to submit Form 9465 electronically to IRS.
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col col-6">
            <button class="btn btn-primary mr-2"
              @click="onConfirmForm9465()"
              :disabled="form9465InProgress">
              Submit &nbsp;<font-awesome-icon icon="fa-regular fa-clock" v-if="form9465InProgress"/>
            </button>
            <button class="btn btn-outline-secondary" @click="closeForm9465Dialog()">
              Cancel
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
        ref="f9645ModalErrorCodes"
        title="Form 9465 Error Codes"
        hide-footer
      >
        <div class="row">
          <div class="col-12" v-if="!!record.efileErrorCodes && !!record.efileErrorCodes.entries && record.efileErrorCodes.entries.length > 0">
            <div v-for="(error, idx) in record.efileErrorCodes.entries" class="mb-2">
              <b>{{error.ruleNum}}</b><br/>
              <span>{{error.errorMessageTxt}}</span>
            </div>
          </div>
        </div>
        <hr />
        <div>
          <button class="btn btn-outline-secondary" @click="closeForm9465ErrorCodesModal()">
            Cancel
          </button>
        </div>
      </b-modal>

      <div
        class="d-flex flex-row justify-content-start mt-4 align-middle"
        style="gap: 32px"
      >
        <div>
          <button
            class="btn btn-secondary font-weight-bold"
            v-on:click="backToResults"
            :disabled="disableButtons"
          >
            &lt; Back to<br class="hide-br" />&nbsp;&nbsp; Results
          </button>
        </div>
        <div class="d-flex flex-column" style="font-size: 20px; color: black">
          <div><b>Order #: </b> {{ record.orderNum }}</div>
          <div>
            <b>Product: </b>
            <span v-if="record.product === 'PaymentPlan'">
              <span v-if="record.isCalifornia">California Payment Plan</span>
              <span v-else-if="record.isNewJersey">New Jersey Payment Plan</span>
              <span v-else-if="record.isGeorgia">Georgia Payment Plan</span>
              <span v-else-if="record.isIllinois">Illinois Payment Plan</span>
              <span v-else-if="record.isMichigan">Michigan Payment Plan</span>
              <span v-else>IRS Payment Plan</span>
            </span>
            <span v-if="record.product !== 'PaymentPlan'">{{ record.product }}</span>
          </div>
        </div>

        <div class="mt-3">
          <button
            :class="['btn', 'btn-secondary', 'font-weight-bold']"
            @click="isEditMode = true"
            :disabled="disableButtons || record.status == 'Charge Back' || record.status == 'Cancelled'"
            v-if="editRecordAuth"
          >
            <!-- <font-awesome-icon :icon="['fa', 'pencil-alt']" />-->
            Edit
          </button>
        </div>
        <div class="mt-3">
          <button
            class="btn btn-warning font-weight-bold"
            @click="saveOrderDetails()"
            :disabled="disableButtons || !isEditMode"
          >
            Save Order Details
          </button>
          <div class="text-success" v-if="addressesSaved">Details Saved</div>
        </div>
      </div>
      <hr />

      <div class="row">
        <div
          class="d-flex col-12 col-sm-6 col-md-6 flex-column"
          style="border-right: 4px solid black; display: none"
        >
          <div class="d-flex mb-3">
            <h3>Basic Info</h3>
          </div>
          <div class="d-flex mb-3 align-middle">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Submitted Date:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              {{ timetoEst(record.createdDate) }}
            </div>
          </div>
          <div class="d-flex mb-3 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Customer IP:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              {{ record.customerIpAddress }}
            </div>
          </div>
          <div class="d-flex mb-3 align-items-center" v-if="record.efileStatus == 'Accepted'">
            <div class="col-12 col-sm-6 col-md-6">
              <b>IRS E-file Confirmation Number:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <b>{{ record.efileSubmissionId }}</b>
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center" v-if="record.efileStatus != 'Accepted'">
            <div class="col-12 col-sm-6 col-md-6">
              <b>USPS Tracking Number:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                class="usps-tracking-input form-control"
                @click="goToTracking()"
                :value="record.trackingNumber"
                readonly="readonly"
                v-if="!isEditMode"
              />
              <input
                class="form-control"
                type="text"
                v-model.trim="record.trackingNumber"
                v-if="isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>First Name:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.firstName"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Last Name:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.lastName"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Email:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.email"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Phone:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.phone"
                :disabled="!isEditMode"
              />
            </div>
          </div>

          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Is E-File?</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="checkbox"
                style="transform: scale(1.5); margin-left: 4px;"
                v-model="record.isEfile"
                :disabled="!isEditMode"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Birth Date (MM/DD/YYYY):</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                class="form-control"
                type="date"
                v-model="record.birthDate"
                placeholder="MM/DD/YYYY"
                :disabled="!isEditMode || !record.isEfile"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Prior Year AGI:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.priorYearAgi"
                :disabled="!isEditMode || !record.isEfile"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Self-Select PIN:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="number"
                class="form-control"
                v-model="record.priorYearPin"
                :disabled="!isEditMode || !record.isEfile"
              />
            </div>
          </div>

          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Spouse Birth Date (MM/DD/YYYY):</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                class="form-control"
                type="date"
                v-model="record.spouseBirthDate"
                placeholder="MM/DD/YYYY"
                :disabled="!isEditMode || !record.isEfile"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Spouse Prior Year AGI:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="record.spousePriorYearAgi"
                :disabled="!isEditMode || !record.isEfile"
              />
            </div>
          </div>
          <div class="d-flex mb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-6">
              <b>Spouse Self-Select PIN:</b>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
              <input
                type="number"
                class="form-control"
                v-model="record.spousePriorYearPin"
                :disabled="!isEditMode || !record.isEfile"
              />
            </div>
          </div>

          <hr />

          <notes-manager
            :notesHolder="record"
            @onUpdate="onConfirmRefresh"
          />

          <hr />

          <div class="d-flex mb-3">
            <h3>Transaction Info</h3>
          </div>
          <div class="d-flex mb-2 align-middle">
            <table style="width: 100%">
              <tr>
                <td class="font-weight-bold" colspan="2">
                  Basic Information
                </td>
              </tr>
              <tr>
                <td>
                  Charge Amount:
                </td>
                <td>${{ parseInt(record.amount, 10) / 100 }}</td>
              </tr>
              <tr>
                <td>
                  Card Brand:
                </td>
                <td>
                  {{ record.cardBrand }}
                </td>
              </tr>
              <tr>
                <td>Last Four of Card Number</td>
                <td>{{record.last4DigitsCard}}</td>
              </tr>

              <tr>
                <td>Original Payment Date</td>
                <td>{{timetoEst(record.submissionDate)}}</td>
              </tr>

              <tr>
                <td class="font-weight-bold" colspan="2">Refund Information</td>
              </tr>
              <tr>
                <td>Voided</td>
                <td>{{ record.status != 'Cancelled' ? '' : record.refundDate ? '' :  'Yes' }}</td>
              </tr>
              <tr>
                <td>Refunded</td>
                <td>{{ record.status == 'Cancelled' && !record.refundDate ? '' : record.refundDate ? 'Yes' :  ''}}</td>
              </tr>


              <tr>
                <td>Refund Orbital Transaction ID</td>
                <td>{{ record.refundAuthTransId }}</td>
              </tr>

              <tr>
                <td>Refund Date</td>
                <td>{{ record.refundDate != null ? new Date(record.refundDate).toLocaleDateString() : '' }}</td>
              </tr>

              <tr>
                <td class="font-weight-bold" colspan="2">
                  Orbital Information
                </td>
              </tr>

              <tr>
                <td>Orbital Original Transaction ID</td>
                <td>{{record.orbitalTransactionNumber}}</td>
              </tr>
              <tr>
                <td>Orbital Decline Reason</td>
                <td>{{record.authorizeErrorMessage}}</td>
              </tr>
              <tr>
                <td>Orbital Error Code</td>
                <td>{{ record.authorizeErrorCode == "00" ? "" : record.authorizeErrorCode }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold" colspan="2">Cardinal 3D Secure Information</td>
              </tr>
              <tr>
                <td>Cardinal Trans ID</td>
                <td>{{ record.transactionId }}</td>
              </tr>
              <tr>
                <td>ECI Code</td>
                <td>{{record.eciFlag}}</td>
              </tr>
              <tr>
                <td>Authentication Result</td>
                <td>{{record.authErrorDesc}}</td>
              </tr>
              <tr>
                <td>Cardinal Response</td>
                <td>{{ record.authErrorDesc == "Success" ? "YAY" : ""}}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="d-flex col-12 col-sm-6 col-md-6 flex-column">
          <div class="d-flex mb-3">
            <h3>Status</h3>
          </div>
          <div class="d-flex flex-column mb-2 align-middle">
            <div class="d-flex mb-3">
              <b class="mt-2">{{ record.status }}</b>
              <div class="ml-3"
                v-if="
                (record.status !== 'Cancelled') &&
                (loggedInUser.userType == 'admin' ||
                (loggedInUser.userType == 'StandardUser' && loggedInUser.manualStatusChange))
              ">
                <select
                  class="form-control"
                  v-model="manualStatus"
                  @change="$refs.manualStatusChangeModal.show()"
                >
                  <option value="" disabled selected hidden>Change Status...</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </div>
            </div>
            <div class="d-flex" style="gap: 20px">
              <div v-if="record.status !== 'Cancelled'">
                <button
                  class="btn btn-secondary font-weight-bold"
                  @click="showHideCancelOrderConfirmation(true)"
                  v-if="statusChangeAuth"
                  :disabled="isChargeBackAvailable(record.status)"
                >
                  Cancel <span v-if="record.amount !== '0'">and Refund</span>
                </button>
              </div>
              <div v-if="record.status !== 'Cancelled' && record.status !== 'Incomplete'">
                <button
                  class="btn btn-secondary font-weight-bold"
                  @click="clickOnHoldButton()"
                  v-if="statusChangeAuth"
                  :disabled="disableButtons && !isEditMode"
                >
                  {{ record.status === "On Hold" ? "Remove Hold" : "Put On Hold" }}
                </button>
              </div>
              <div v-if="record.amount !== '0' && record.status !== 'Incomplete'">
                <button
                  class="btn btn-secondary font-weight-bold"
                  @click="clickOnChargebackButton()"
                  :disabled="isChargeBackAvailable(record.status)"
                  v-if="
                    loggedInUser.userType == 'admin' ||
                    (loggedInUser.userType == 'StandardUser' &&
                      loggedInUser.chargebackAuth)
                  "
                >
                  Chargeback
                </button>
              </div>
            </div>
          </div>

          <hr />

          <div class="d-flex mb-3">
            <h3>Customer Documents</h3>
          </div>
          <div class="d-flex flex-column mb-2 align-middle">
            <div
              v-if="pdfOrderVersions && pdfOrderVersions.length > 0"
              class="d-flex mb-3"
              style="gap: 20px"
            >
              <div
                style="color: #2e85f5; cursor: pointer"
                @click="pdfVersion(pdfOrderVersions[pdfOrderVersions.length - 1])"
              >
                <u>
                  <b
                    >{{
                      pdfOrderVersions &&
                      pdfOrderVersions[pdfOrderVersions.length - 1].versionId
                    }}.pdf</b
                  ></u
                >
              </div>
              <div>
                {{
                  pdfOrderVersions &&
                  pdfOrderVersions[pdfOrderVersions.length - 1].createdDate
                }}
              </div>
            </div>

            <div class="d-flex mb-3">
              <button @click="emailPdfCopy()" class="btn btn-secondary font-weight-bold">
                Email Customer Copy >
              </button>
              <div v-if="record.status == 'Completed' && record.trackingNumber">
                <button
                  class="btn btn-secondary font-weight-bold ml-2"
                  @click="clickOnPhysicalCopy()"
                >
                  Mail New Physical Copy
                </button>
              </div>
            </div>

            <div class="d-flex">Previous Versions:</div>

            <div v-if="!pdfOrderVersions || pdfOrderVersions.length <= 1">
              <i>No PDF version found</i>
            </div>
            <div v-if="pdfOrderVersions && pdfOrderVersions.length > 1">
              <div
                class="d-flex"
                style="gap: 20px"
                v-for="(version, index) in pdfOrderVersions.slice().reverse()"
                :key="version.createdDate"
              >
                <div
                  v-if="index != 0"
                  style="color: #2e85f5; cursor: pointer"
                  @click="pdfVersion(version)"
                >
                  <u
                    ><b>{{ version.versionId }}.pdf</b></u
                  >
                </div>
                <div v-if="index != 0">
                  {{ version.createdDate }}
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div v-if="(loggedInUser.userType === 'admin' || (loggedInUser.userType === 'StandardUser' && loggedInUser.irsEfileSubmission))
                      && record.product === 'PaymentPlan'
                      && !(record.isCalifornia || record.isNewJersey || record.isGeorgia || record.isIllinois || record.isMichigan)">
            <div class="d-flex mb-3">
              <h3>Modernized e-File</h3>
            </div>
            <div class="d-flex flex-column mb-2 align-middle"
              v-if="!['Processing', 'Completed'].includes(record.status)">
              <span>This section is for orders in <b>Processing</b> and <b>Completed</b> statuses.</span>
            </div>

            <div class="d-flex flex-column mb-2 align-middle"
              v-if="['Processing', 'Completed'].includes(record.status)">
              <div class="d-flex">
                <b>Sample files</b>&nbsp;
                <span class="help-color"
                  v-b-popover.hover.bottom="
                    'Submission and manifest samples, files sent to IRS might be different (e.g. date-time specific fields)'
                  ">
                  <font-awesome-icon icon="circle-question"/>
                </span>
              </div>
              <div class="d-flex"
                style="gap: 20px">
                <div
                  style="color: #2e85f5; cursor: pointer"
                  @click="downloadSubmissionXMLSample(record.orderNum)">
                  <u><b>submission_sample.xml</b></u>
                </div>
              </div>
              <div class="d-flex mb-3"
                style="gap: 20px">
                <div
                  style="color: #2e85f5; cursor: pointer"
                  @click="downloadManifestXMLSample(record.orderNum)">
                  <u><b>manifest_sample.xml</b></u>
                </div>
              </div>

              <div class="d-flex mb-3">
                <button @click="onForm9465()"
                        class="btn btn-secondary font-weight-bold mr-3"
                        :disabled="disableButtons || !['Processing', 'Completed'].includes(record.status) || form9465NotAllowed">
                  Send 9465
                </button>
                <button @click="fetchAckResponse()"
                        class="btn btn-primary font-weight-bold"
                        :disabled="disableButtons || !['Ack Response Error'].includes(record.efileStatus) || fetchAckInProgress">
                  Fetch Ack Response &nbsp;<font-awesome-icon icon="fa-regular fa-clock" v-if="fetchAckInProgress"/>
                </button>

                <span class="warning-color" style="margin-top: 5px; margin-left: 5px;"
                  v-if="form9465NotAllowed"
                  v-b-popover.hover.bottom="
                    'e-File is not an option if amount owed is over $50,000 or if payroll deduction option is selected'
                  ">
                  <font-awesome-icon icon="fa-solid fa-exclamation-circle"/>
                </span>
              </div>

              <div class="d-flex"><b>9465 Result:</b></div>
              <div v-if="!record.efileSubmission">
                <i>Not submitted yet</i>
              </div>
              <div v-if="!!record.efileSubmission">
                <div class="d-flex">
                  <div
                    style="color: #2e85f5; cursor: pointer"
                    @click="downloadSubmissionXML(record.orderNum)">
                    <u><b>submission_{{record.orderNum}}.xml</b></u>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  <div
                    style="color: #2e85f5; cursor: pointer"
                    @click="downloadManifestXML(record.orderNum)">
                    <u><b>manifest_{{record.orderNum}}.xml</b></u>
                  </div>
                </div>

                <div class="d-flex">
                  <span>
                    Submission Id: <b>{{record.efileSubmissionId}}</b>
                  </span>
                </div>

                <div class="d-flex" v-if="!!record.efileSubmissionDate">
                  <span>
                    Submission Date: <b>{{record.efileSubmissionDate}}</b>
                  </span>
                </div>

                <div class="d-flex">
                  <span>
                    Status: <b :style="record.efileStatus == 'Accepted' ? 'color: green;' : 'color: red;'">
                      {{record.efileStatus}}
                    </b>
                  </span>
                </div>

                <!-- TODO: Handle PIN codes if logic will be changed, currently constant values -->
                <div class="d-flex">
                  <span>
                    User PIN: <b>82549</b>
                  </span>
                </div>
                <div class="d-flex">
                  <span>
                    Practitioner PIN: <b>82549</b>
                  </span>
                </div>

                <div v-if="!!record.efileAckResponse">
                  <div class="d-flex" v-if="!!record.efileErrorCodes && !!record.efileErrorCodes.entries && record.efileErrorCodes.entries.length > 0">
                    <span>
                      Error Codes: <a
                         style="color: #2e85f5; cursor: pointer"
                         @click="onForm9465ErrorCodes()">
                         <b>{{form9465ErrorCodesLabel()}}</b>
                       </a>
                    </span>
                  </div>

                  <div class="d-flex mt-2">
                    <!-- TODO: Might be needed later
                    <i v-if="!record.efileStatus">No ack response yet</i>
                    -->

                    <div
                      style="color: #2e85f5; cursor: pointer"
                      @click="downloadAckResponseXML(record.orderNum)">
                      <u><b>ack_response_{{record.orderNum}}.xml</b></u>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr />
          </div>

          <div class="d-flex mb-3">
            <h3>Mailing Address</h3>
          </div>

          <div class="d-flex flex-column mb-2 align-middle">
            <div class="d-flex">
              <input
                type="text"
                class="form-control"
                v-model="record.shippingAddress1"
                :disabled="!isEditMode"
              />
            </div>
            <div class="d-flex">
              <input
                type="text"
                class="form-control"
                v-model="record.shippingAddress2"
                :disabled="!isEditMode"
              />
            </div>
            <div class="d-flex flex-row">
              <input
                type="text"
                class="form-control"
                v-model="record.shippingCity"
                :disabled="!isEditMode"
              />
              <input
                type="text"
                class="form-control"
                v-model="record.shippingState"
                :disabled="!isEditMode"
              />
              <input
                type="text"
                class="form-control"
                v-model="record.shippingZip"
                :disabled="!isEditMode"
              />
            </div>
          </div>

          <hr />

          <div class="d-flex mb-3">
            <h3>Additional Details</h3>
          </div>

          <div class="d-flex flex-column mb-2 align-middle">
            <admin-payment-plan
              v-if="record.product === 'PaymentPlan'"
              :loggedInUser="loggedInUser"
              :orderInput="record"
              ref="paymentPlan"
              :isEditMode="isEditMode"
            >
            </admin-payment-plan>

            <admin-tax-lien-removal
              v-if="record.product === 'TaxLienRemoval'"
              :orderNum="record.orderNum"
              ref="taxlienRemoval"
              :isEditMode="isEditMode"
            >
            </admin-tax-lien-removal>

            <admin-offer-in-compromise
              v-if="record.product === 'OfferInCompromise'"
              :orderNum="record.orderNum"
            >
            </admin-offer-in-compromise>
          </div>

          <hr v-if="record.isNewJersey && record.isOwedFromBusiness" />
          <div class="mb-2" v-if="record.isNewJersey && record.isOwedFromBusiness">
            <h3>Business Physical Address</h3>
          </div>

          <div
            class="flex-column align-middle business-address"
            v-if="record.isNewJersey"
          >
            <div>
              <label>Business Address Line 1</label>
              <input
                type="text"
                placeholder="Street Address"
                class="form-control"
                v-model="record.businessAddress1"
                :disabled="!isEditMode"
              />
            </div>
            <div>
              <label>Business Address Line 2</label>
              <input
                type="text"
                placeholder="Street Address"
                class="form-control"
                v-model="record.businessAddress2"
                :disabled="!isEditMode"
              />
            </div>
            <div class="row">
              <div class="col-6">
                <label>City</label>
                <input
                  type="text"
                  placeholder="City"
                  class="form-control"
                  v-model="record.businessCity"
                  :disabled="!isEditMode"
                />
              </div>
              <div class="col-3">
                <label>State</label>
                <input
                  type="text"
                  placeholder="State"
                  class="form-control"
                  v-model="record.businessState"
                  :disabled="!isEditMode"
                />
              </div>
              <div class="col-3">
                <label>Zip Code</label>
                <input
                  type="text"
                  placeholder="Zip Code"
                  class="form-control"
                  v-model="record.businessZip"
                  :disabled="!isEditMode"
                />
              </div>
            </div>
          </div>

          <hr />
          <div class="d-flex mb-3">
            <h3>Billing Address</h3>
          </div>

          <div class="d-flex flex-column mb-2 align-middle">
            <div class="d-flex">
              <input
                type="text"
                class="form-control"
                v-model="record.billingAddress1"
                :disabled="!isEditMode"
              />
            </div>
            <div class="d-flex">
              <input
                type="text"
                class="form-control"
                v-model="record.billingAddress2"
                :disabled="!isEditMode"
              />
            </div>
            <div class="d-flex flex-row">
              <input
                type="text"
                class="form-control"
                v-model="record.billingCity"
                :disabled="!isEditMode"
              />
              <input
                type="text"
                class="form-control"
                v-model="record.billingState"
                :disabled="!isEditMode"
              />
              <input
                type="text"
                class="form-control"
                v-model="record.billingZip"
                :disabled="!isEditMode"
              />
            </div>
          </div>
        </div>
      </div>

      <br />
      <div class="row" style="display: none">
        <div class="col" style="border-right: 4px solid black">
          <br />
          <div v-if="record != null">

            <br />
            <div class="row" v-if="record.partnerCode">
              <label class="col-6 col-form-label font-weight-bold">Promo Code:</label>
              <div class="col col-6 py-2">
                {{ record.partnerCode }}
              </div>
            </div>

            <br />
            <br />
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-6">
          <div v-if="record != null">

            <br />

            <!-- <div class="row">
          <label class="col-5 col-form-label font-weight-bold">Transaction ID (Cardinal):</label>
      <div class="col-7">
            {{record.transactionId}}
      </div>
    </div>

      <div class="row">
        <label class="col-5 col-form-label font-weight-bold">Auth Response Code:</label>
        <div class="col-7">
          {{record.authorizeResponseCode}}
        </div>
      </div>
      <div class="row">
        <label class="col-5 col-form-label font-weight-bold">Auth Message Code:</label>
        <div class="col-7">
          {{record.authorizeMessageCode}}
        </div>
      </div>



      <div class="row">
        <label class="col-5 col-form-label font-weight-bold">Auth Description:</label>
        <div class="col-7">
          {{record.authorizeDescription}}
        </div>
      </div>
      <div class="row">
        <label class="col-5 col-form-label font-weight-bold">Auth Code:</label>
        <div class="col-7">
          {{record.authorizeAuthCode}}
        </div>
      </div>
      <div class="row">
        <label class="col-5 col-form-label font-weight-bold">Auth Error Code:</label>
        <div class="col-7">
          {{record.authorizeErrorCode}}
        </div>
      </div>
      <div class="row">
        <label class="col-5 col-form-label font-weight-bold">Auth Error Message:</label>
        <div class="col-7">
          {{record.authorizeErrorMessage}}
        </div>
      </div> -->
            <!-- <div class="row">
          <div class="col col-3" v-if="record.status !== 'Incomplete'">
            <button class="btn btn-warning" @click="chargeback()" :disabled="disableButtons && !isEditMode || record.status=='Charge Back'" v-if="loggedInUser.userType=='admin' || (loggedInUser.userType=='StandardUser' && loggedInUser.chargebackAuth)">Chargeback</button>
          </div>
      </div> -->

            <div v-if="record.product === 'OfferInCompromise'">
              <h2 class="mt-4">Offer In Compromise</h2>
              <admin-offer-in-compromise
                :orderNum="record.orderNum"
              ></admin-offer-in-compromise>
            </div>

            <div v-if="record.product === 'TaxLienRemoval'">
              <h2 class="mt-4">Tax Lien Removal</h2>
              <admin-tax-lien-removal
                :orderNum="record.orderNum"
                ref="taxlienRemoval"
                :isEditMode="isEditMode"
              ></admin-tax-lien-removal>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="backConfirmation" hide-footer title="Alert">
      <div class="row">
        <div class="col">
          <p>Are you sure? Edits are not saved!</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button
            class="btn btn-success pl-4 pr-4 text-dark"
            @click="backToResults(true)"
          >
            <b>YES</b>
          </button>
          <button
            class="btn btn-warning pl-4 pr-4 text-dark"
            @click="backToResults(false)"
          >
            <b>NO</b>
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="physicalCopyModal" hide-footer :title="'New Physical Copy'">
      <div class="row">
        <div class="col">
          <p>Would you like to send an email notification to the customer?</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-success" @click="physicalCopy(true)">
            Send Notification
          </button>
          <button class="btn btn-warning" @click="physicalCopy(false)">Don't Send</button>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="offHoldModal"
      hide-footer
      :title="record.status === 'On Hold' ? 'Take Off Hold' : 'Put On Hold'"
    >
      <div class="row">
        <div class="col">
          <p>Would you like to send an email notification to the customer?</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-success" @click="putOnHold(true)">
            Send Notification
          </button>
          <button class="btn btn-warning" @click="putOnHold(false)">Don't Send</button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="cbStatusModal" hide-footer title="Chargeback Status">
      <div class="row">
        <div class="col">
          <p>Is this a CDRN or Chase Chargeback?</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-success" @click="chargebackCDRN()">CDRN</button>
          <button class="btn btn-warning" @click="chargebackChase()">CHASE</button>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="emailNotificationModel"
      hide-footer
      :title="emailNotificationModelData.title"
    >
      <div class="row">
        <div class="col">
          <p>{{ emailNotificationModelData.content }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-success" @click="sendEmailNotification(true)">
            {{ emailNotificationModelData.sendButtonText }}
          </button>
          <button class="btn btn-warning" @click="sendEmailNotification(false)">
            {{ emailNotificationModelData.cancelButtonText }}
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="cancelOrderModel" hide-footer title="Cancel Order">
      <div class="row">
        <div class="col">
          <p>Are you sure?</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-success ml-1 float-right" @click="cancelOrder()">
            Yes
          </button>
          <button
            class="btn btn-warning float-right"
            @click="showHideCancelOrderConfirmation(false)"
          >
            No
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="manualStatusChangeModal" hide-footer title="Manual Status Change" @hidden="manualStatusChangeModalHidden()">
      <div class="row">
        <div class="col">
          <p>You are manually changing a status, are you sure?</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-success ml-1 float-right" @click="manualStatusChange()">
            Yes
          </button>
          <button
            class="btn btn-warning float-right"
            @click="hideManualStatusChangeModal()"
          >
            No
          </button>
        </div>
      </div>
    </b-modal>
  </page>
</template>

<!-- sharea sale tag -->
<script>
var shareasaleSSCID = shareasaleGetParameterByName("sscid");
function shareasaleSetCookie(e, a, r, s, t) {
  if (e && a) {
    var o,
      n = s ? "; path=" + s : "",
      i = t ? "; domain=" + t : "",
      l = "";
    r &&
      ((o = new Date()).setTime(o.getTime() + r), (l = "; expires=" + o.toUTCString())),
      (document.cookie = e + "=" + a + l + n + i);
  }
}
function shareasaleGetParameterByName(e, a) {
  a || (a = window.location.href), (e = e.replace(/[\[\]]/g, "\\$&"));
  var r = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(a);
  return r ? (r[2] ? decodeURIComponent(r[2].replace(/\+/g, " ")) : "") : null;
}
shareasaleSSCID &&
  shareasaleSetCookie("shareasaleSSCID", shareasaleSSCID, 94670778e4, "/");
</script>

<script>
import { AXIOS } from "../scripts/http-common";
import { methods } from "../shared/methods";
import { clone } from "lodash";
import moment, {ISO_8601} from "moment";
import NotesManager from "./common/NotesManager.vue";

export default {
  components: {
    NotesManager
  },
  data() {
    return {
      isEditMode: false,
      notificationSent: false,
      showSsn: false,
      record: {
        birthDate: undefined,
        spouseBirthDate: undefined
      },
      pastRecord: {},
      paymentPlanDetails: null,
      transactionStatus: null,
      disableButtons: false,
      form9465InProgress: false,
      fetchAckInProgress: false,
      form9465NotAllowed: false,
      notesSaved: false,
      addressesSaved: false,
      loggedInUser: "",
      ssnToShow: "",
      statusChangeAuth: false,
      editRecordAuth: false,
      voidRefundAuth: false,
      pdfOrderVersions: null,
      loaderOn: false,
      manual_note: "",
      put_on_hold: "",
      emailNotificationModelData: {
        title: "",
        content: "",
        sendButtonText: "Send Notification",
        cancelButtonText: "Don’t Send",
      },
      refundFlag: true,
      cancelFlag: true,
      manualStatus: "",
    };
  },
  methods: {
    timetoEst(datestring) {
      if (!datestring) {
        return "";
      }
      const yymmdd = moment(datestring).format("YYYY-MM-DD");

      if (yymmdd < "2023-04-26") {
        return moment
          .utc(datestring)
          .tz("America/New_York")
          .format("M/D/YYYY hh:mm:ss A");
      } else {
        return datestring;
      }
    },
    form9465ErrorCodesLabel() {
      let errors = this.record.efileErrorCodes;
      if (!errors) {
        return "";
      }
      errors = errors.entries;
      if (!errors || errors.length == 0) {
        return "";
      }

      if (errors.length == 1) {
        return errors[0].ruleNum;
      }
      if (errors.length == 2) {
        return errors[0].ruleNum + ", " + errors[1].ruleNum;
      }
      return errors[0].ruleNum + ", " + (errors.length - 1) + " others"
    },
    onForm9465ErrorCodes() {
      this.$refs.f9645ModalErrorCodes.show();
    },
    closeForm9465ErrorCodesModal() {
      this.$refs.f9645ModalErrorCodes.hide();
    },
    fetchAckResponse() {
      console.log("Form 9465 ack response fetch confirmed.");

      let self = this;
      self.fetchAckInProgress = true;
      self.disableButtons = true;
      AXIOS.post(`/admin/efile/f9465/fetch-ack/${this.record.orderNum}`)
        .then((response) => {
          self.fetchAckInProgress = false;
          self.disableButtons = false;
          self.refresh();
        })
        .catch((e) => {
          alert("Unable to fetch Form 9465's ack response.");
          self.fetchAckInProgress = false;
          self.disableButtons = false;
        });
    },
    onForm9465() {
      this.$refs.f9645Modal.show();
    },
    closeForm9465Dialog() {
      this.$refs.f9645Modal.hide();
    },
    onConfirmForm9465() {
      console.log("Form 9465 submission confirmed.");

      let self = this;
      self.form9465InProgress = true;
      self.disableButtons = true;
      AXIOS.post(`/admin/efile/f9465/submit/${this.record.orderNum}`)
        .then((response) => {
          self.form9465InProgress = false;
          self.disableButtons = false;
          self.$refs.f9645Modal.hide();
          self.refresh();
        })
        .catch((e) => {
          alert("Unable to submit Form 9465.");
          self.form9465InProgress = false;
          self.disableButtons = false;
        });
    },
    clickOnPhysicalCopy() {
      this.$refs.physicalCopyModal.show();
    },
    physicalCopy(sendNotification) {
      let self = this;
      console.log("[new physical copy clicked!]", sendNotification);
      self.disableButtons = true;
      AXIOS.put(`/admin/order/id/${this.$route.params.id}/physicalCopy`, {
        sendNotification: sendNotification,
        orderNum: this.record.orderNum,
        type: "SYSTEM",
        content: `ORIGINAL TRACKING: ${this.record.trackingNumber}`,
        user: self.loggedInUser.username,
      })
        .then((response) => {
          self.disableButtons = false;
          self.$refs.physicalCopyModal.hide();
          self.refresh();
        })
        .catch((e) => {
          alert("Unable to change status.");
          self.disableButtons = false;
        });
    },

    sendEmailNotification(sendNotification) {
      if (sendNotification) {
        this.disableButtons = true;
        AXIOS.post(`/admin/order/id/${this.record.orderNum}/sendEmailNotification`)
          .then((response) => {
            this.disableButtons = false;
            alert("Email sent!");
          })
          .catch((e) => {
            this.disableButtons = false;
            alert("Unable to send email!");
          });
      }
      this.$refs.emailNotificationModel.hide();
    },

    onRefresh() {
      this.$refs.userModel.show();
    },
    closeRefreshDialog() {
      this.$refs.userModel.hide();
    },
    onConfirmRefresh() {
      let self = this;
      let orderInfo = this.getRecord(
        this.record,
        this.record.product == "TaxLienRemoval"
          ? this.$refs.taxlienRemoval.taxLienRemovalDetails
          : this.$refs.paymentPlan.paymentPlan
      );
      orderInfo.orderNumber = this.record.orderNum;
      orderInfo.totalDebt = this.$refs.paymentPlan.paymentPlan.totalDebt;
      // delete orderInfo.failureReason;
      if (orderInfo.isNewJersey) {
        orderInfo.secondaryPhone = this.record.secondaryPhone;
      }
      AXIOS.post(`/pdforderversion/refreshOrder`, orderInfo)
        .then((response) => {
          self.closeRefreshDialog();
          self.refresh();
        })
        .catch((e) => {
          console.error(e);
          // this.initializeCardinal();
          alert(e.message);
        });
    },
    unpack(str) {
      var bytes = [];
      for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        bytes.push(char >>> 8);
        bytes.push(char & 0xff);
      }
      return bytes;
    },
    emailPdfCopy() {
      this.loaderOn = true;
      let orderInfo = this.getRecord(
        this.record,
        this.record.product == "TaxLienRemoval"
          ? this.$refs.taxlienRemoval.taxLienRemovalDetails
          : this.$refs.paymentPlan.paymentPlan
      );
      orderInfo.orderNumber = this.record.orderNum;
      AXIOS.post("/pdforderversion/emailpdf", orderInfo)
        .then((res) => {
          this.loaderOn = false;
          if (res) {
            alert("Email Sent!");
          } else {
            alert("Something is wrong Email not sent successfully");
          }
        })
        .catch((error) => {
          this.loaderOn = false;
          alert(Error + error);
        });
    },
    pdfVersion(order) {
      window.location = "/api/pdforderversion/pdfDownload/id/" + order.versionId;
    },
    downloadSubmissionXMLSample(orderId) {
      window.location = "/api/admin/efile/f9465/xml/submission/" + orderId + "/sample";
    },
    downloadManifestXMLSample(orderId) {
      window.location = "/api/admin/efile/f9465/xml/manifest/" + orderId + "/sample";
    },
    downloadSubmissionXML(orderId) {
      window.location = "/api/admin/efile/f9465/xml/submission/" + orderId;
    },
    downloadManifestXML(orderId) {
      window.location = "/api/admin/efile/f9465/xml/manifest/" + orderId;
    },
    downloadAckResponseXML(orderId) {
      window.location = "/api/admin/efile/f9465/xml/ack_response/" + orderId;
    },
    toParams(request, params = {}, prefix = null) {
      for (let [key, value] of Object.entries(request)) {
        let newKey = prefix ? `${prefix}.${key}` : key;
        if (value !== null && typeof value === "object") {
          this.toParams(value, params, newKey);
        } else {
          params[newKey] = value;
        }
      }
      return params;
    },
    getRecord(order, @Nullable spouseDetails) {
      let orderDetails = Object.assign({}, order);
      let orderInfo = {
        billingFirstName: order.firstName,
        billingLastName: order.lastName,
        billingPhone: order.phone,
        shippingFirstName: order.firstName,
        shippingLastName: order.lastName,
        shippingPhone: order.phone,
        email: order.email,

        billingAddress1: order.billingAddress1
          ? order.billingAddress1
          : order.shippingAddress1,
        billingAddress2: order.billingAddress2
          ? order.billingAddress2
          : order.shippingAddress2,
        billingCity: order.billingCity ? order.billingCity : order.shippingCity,
        billingState: order.billingState ? order.billingState : order.shippingState,
        billingPostalCode: order.billingZip ? order.billingZip : order.shippingZip,

        shippingAddress1: order.shippingAddress1,
        shippingAddress2: order.shippingAddress2,
        shippingCity: order.shippingCity,
        shippingState: order.shippingState,
        shippingPostalCode: order.shippingZip,

        businessAddress1: order.businessAddress1,
        businessAddress2: order.businessAddress2,
        businessCity: order.businessCity,
        businessState: order.businessState,
        businessPostalCode: order.businessZip,
        physNotMailing: order.physNotMailing,

        employerName: order.employerName,
        employerAddress1: order.employerAddress1,
        employerAddress2: order.employerAddress2,
        employerCity: order.employerCity,
        employerState: order.employerState,
        employerZip: order.employerZip,
        employerContactName: order.employerContactName,
        employerContactPhoneNumber: order.employerContactPhoneNumber,
        payrollDeduction: order.payrollDeduction,
        payFrequency: order.payFrequency,

        amount:
          order.product == "TaxLienRemoval"
            ? order.amount
            : spouseDetails && spouseDetails.totalDebt
            ? spouseDetails.totalDebt
            : order.amount,
        isCalifornia: order.isCalifornia,
        isNewJersey: order.isNewJersey,
        isGeorgia: order.isGeorgia,
        isIllinois: order.isIllinois,
        isMichigan: order.isMichigan,
        isOwedFromBusiness: order.isOwedFromBusiness,
        businessName: order.businessName,
        ein: order.ein,
        dba: order.dba,
        illinoisAccountId: order.illinoisAccountId,
        goodFaithPayment: order.goodFaithPayment,
        mobile: order.mobile,
        totalDebt: order.totalDebt,
        paymentMonths: order.paymentMonths,
        taxLienIsBusiness: spouseDetails
          ? spouseDetails.taxLienIsBusiness
          : order.taxLienIsBusiness,
        taxLienType: spouseDetails ? spouseDetails.taxLienType : order.taxLienType,
        taxLienBusinessName: spouseDetails
          ? spouseDetails.taxLienBusinessName
          : order.taxLienBusinessName,
        taxLienBusinessEin: spouseDetails
          ? spouseDetails.taxLienBusinessEin
          : order.taxLienBusinessEin,
        taxLienRemediationType: spouseDetails
          ? spouseDetails.taxLienRemediationType
          : order.taxLienRemediationDescription,
        taxLienRemediationDescription: spouseDetails
          ? spouseDetails.taxLienRemediationDescription
          : order.taxLienRemediationDescription,
        taxLienAutomaticDebit:
          spouseDetails && spouseDetails.taxLienAutomaticDebit
            ? spouseDetails.taxLienAutomaticDebit
            : order.taxLienAutomaticDebit
            ? order.taxLienAutomaticDebit
            : false,
        serialNumber: spouseDetails ? spouseDetails.serialNumber : order.serialNumber,

        ssn: order.ssn,
        married: spouseDetails ? spouseDetails.married : order.married,
        spouseFirstName: spouseDetails
          ? spouseDetails.spouseFirstName
          : order.spouseFirstName,
        spouseLastName: spouseDetails
          ? spouseDetails.spouseLastName
          : order.spouseLastName,
        spouseSsn:
          spouseDetails && spouseDetails.spouseSsn
            ? spouseDetails.spouseSsn
            : !spouseDetails
            ? order.spouseSsn
            : "",
        timeToCall: spouseDetails ? spouseDetails.timeToCall : order.timeToCall,
        paymentDayOfMonth: spouseDetails
          ? spouseDetails.paymentDayOfMonth
          : order.paymentDayOfMonth,

        cardNumber: order.cardNumber ? order.cardNumber : "",
        cardExpMonth: order.cardExpMonth ? order.cardExpMonth : "",
        cardExpYear: order.cardExpYear ? order.cardExpYear : "",
        cardCvc: order.cardCvc ? order.cardCvc : "",

        product: order.product,
        responseJwt: order.responseJwt ? order.responseJwt : "",
        failureReason: order.failureReason ? order.failureReason : "",
        submissionDate: new Date(order.submissionDate),
        status: order.status,
        hasOldAddress: order.hasOldAddress ? order.hasOldAddress : false,
        oldAddress1: order.oldAddress1 ? order.oldAddress1 : "",
        oldAddress2: order.oldAddress2 ? order.oldAddress2 : "",
        oldCity: order.oldCity ? order.oldCity : "",
        oldState: order.oldState ? order.oldState : "",
        oldZip: order.oldZip ? order.oldZip : "",
      };
      return orderInfo;
    },

    chargebackCDRN() {
      let self = this;
      this.disableButtons = true;

      const authTransactionId = this.record.authorizeTransactionId;
      AXIOS.put(`/v2/admin/transaction/${authTransactionId}/voidOrRefundOnChargeBack`, {
        cbtype: 1,
        sendNotification: false,
        orderNum: this.record.orderNum,
        type: "SYSTEM",
        content: "CDRN C/B DNS",
        user: self.loggedInUser.username,
      })
        .then((res) => {
          if (res.data.responseIdentifier != "Success") {
            this.alertManager("Chargeback");
            return;
          }

          alert("Transaction has chargeback");
          this.disableButtons = false;
          this.refresh();
          this.$refs.cbStatusModal.hide();
        })
        .catch((e) => {
          if (e.response.status === 409) {
            alert("Order void/refund can't be done more often than once in 10 seconds, please retry in short.");
            this.disableButtons = false;
            this.refresh();
            this.$refs.cbStatusModal.hide();
          } else {
            this.alertManager("Chargeback");
          }
        });
    },

    chargebackChase() {
      let self = this;
      this.disableButtons = true;

      const authTransactionId = this.record.authorizeTransactionId;
      AXIOS.put(`/v2/admin/transaction/${authTransactionId}/voidOrRefundOnChargeBack`, {
        cbtype: 2,
        sendNotification: false,
        orderNum: this.record.orderNum,
        type: "SYSTEM",
        content: "CHASE C/B DNS",
        user: self.loggedInUser.username,
      })
        .then((res) => {
          let message = res.data.responseIdentifier == "Success"
            ? "Transaction has chargeback"
            : "Chargeback is not successful, alert a Manager to manually process the chargeback";

          alert(message);
          this.disableButtons = false;
          this.refresh();
          this.$refs.cbStatusModal.hide();
        })
        .catch((e) => {
          if (e.response.status === 409) {
            alert("Order void/refund can't be done more often than once in 10 seconds, please retry in short.");
          } else {
            alert("Chargeback is not successful, alert a Manager to manually process the chargeback");
          }
          this.disableButtons = false;
          this.refresh();
          this.$refs.cbStatusModal.hide();
        });
    },

    clickOnChargebackButton() {
      this.$refs.cbStatusModal.show();
    },

    clickOnHoldButton() {
      this.$refs.offHoldModal.show();
      this.record.status === "On Hold"
        ? (this.put_on_hold = "REMOVE HOLD")
        : (this.put_on_hold = "PUT ON HOLD");
    },
    putOnHold(sendNotification) {
      let self = this;

      console.log("[put on hold clicked!]", sendNotification);

      self.disableButtons = true;
      AXIOS.put(`/admin/order/id/${this.$route.params.id}/onhold`, {
        sendNotification: sendNotification,
        orderNum: this.record.orderNum,
        type: "SYSTEM",
        content: this.put_on_hold,
        user: self.loggedInUser.username,
      })
        .then((response) => {
          self.disableButtons = false;
          this.$refs.offHoldModal.hide();
          this.refresh();
        })
        .catch((e) => {
          alert("Unable to change status.");
          self.disableButtons = false;
        });
    },
    showHideCancelOrderConfirmation(isOpen) {
      isOpen ? this.$refs.cancelOrderModel.show() : this.$refs.cancelOrderModel.hide();
    },

    alertManager(process) {
      let successMessage = process + " is not successful, alert email is sent to a Manager";
      let failureMessage = process + " is not successful, error occurred while sending alert email to a Manager. Please alert a Manager to manually process the " + process.toLowerCase();

      AXIOS.put(`/alerts/notify/refund`, {
          orderPath: `/admin/order/${this.$route.params.id}`
        })
        .then((res) => {
          let informed = res.data.responseIdentifier === "Informed";
          alert(informed ? successMessage : failureMessage);
          this.$refs.cbStatusModal.hide();
          this.disableButtons = false;
          this.refresh();
        })
        .catch((e) => {
          alert(failureMessage);
          this.$refs.cbStatusModal.hide();
          this.disableButtons = false;
          this.refresh();
        });
    },

    cancelOrder() {
      this.showHideCancelOrderConfirmation();
      let self = this;
      this.disableButtons = true;

      const authTransactionId = this.record.authorizeTransactionId;
      AXIOS.put(`/v2/admin/transaction/${authTransactionId}/void`, {
          sendNotification: false,
          orderNum: this.record.orderNum,
          type: "SYSTEM",
          content: "CANCEL AND REFUND",
          user: self.loggedInUser.username,
        })
        .then((res) => {
          if (res.data.responseIdentifier != "Success") {
            this.alertManager("Refund");
            return;
          }

          alert("Transaction has voided");
          this.disableButtons = false;
          this.refresh();
        })
        .catch((e) => {
          if (e.response.status === 409) {
            alert("Order void/refund can't be done more often than once in 10 seconds, please retry in short.");
            this.disableButtons = false;
            this.refresh();
          } else {
            this.alertManager("Refund");
          }
        });
    },

    hideManualStatusChangeModal() {
      this.manualStatus = "";
      this.$refs.manualStatusChangeModal.hide();
    },

    manualStatusChangeModalHidden() {
      this.manualStatus = "";
    },

    manualStatusChange() {
      if (this.manualStatus != "Cancelled") { // Currently supporting only one status
        return;
      }

      let self = this;
      AXIOS.put(`/admin/order/id/${this.$route.params.id}/cancel`, {
        sendNotification: false,
        orderNum: this.record.orderNum,
        type: "SYSTEM",
        content: "MANUALLY CANCELLED",
        user: self.loggedInUser.username,
      })
        .then((response) => {
          self.disableButtons = false;
          self.hideManualStatusChangeModal();
          self.refresh();
        })
        .catch((e) => {
          console.log(e);
          alert("Unable to manually change order's status");
          self.disableButtons = false;
          self.hideManualStatusChangeModal();
          self.refresh();
        });
    },

    refresh() {
      this.disableButtons = true;
      let self = this;
      AXIOS.get(`/admin/order/id/${this.$route.params.id}`)
        .then((response) => {
          let params = Object.assign(
            {},
            this.toParams({ orderId: this.$route.params.id })
          );
          AXIOS.get(`/pdforderversion/getOrder/id/${this.$route.params.id}`, {
            params: params,
          })
            .then((orders) => {
              self.pdfOrderVersions = [...orders.data];
              self.$set(self, "record", response.data);
              self.pastRecord = clone(response.data);
              let today = new Date();
              let orderCreatedDate = new Date(self.record.createdDate);
              let dateDifference = Math.round(today - orderCreatedDate);
              let weekDifference = Math.round(dateDifference / 1000 / 60 / 60 / 24 / 7);
              let weeksAllowedToChangeStatus = self.loggedInUser.orderStatus;
              let weeksAllowedToEdit = self.loggedInUser.editRecord;
              let weeksAllowedToRefund = self.loggedInUser.refundPayment;

              if (
                self.loggedInUser.userType == "admin" ||
                (self.loggedInUser.userType == "StandardUser" &&
                  weekDifference <= weeksAllowedToChangeStatus)
              ) {
                self.statusChangeAuth = true;
              }
              if (
                self.loggedInUser.userType == "admin" ||
                (self.loggedInUser.userType == "StandardUser" &&
                  weekDifference <= weeksAllowedToEdit)
              ) {
                self.editRecordAuth = true;
              }
              if (
                self.loggedInUser.userType == "admin" ||
                (self.loggedInUser.userType == "StandardUser" &&
                  weekDifference <= weeksAllowedToRefund)
              ) {
                self.voidRefundAuth = true;
              }
              this.disableButtons = false;
              this.form9465NotAllowed = this.record.totalDebt > 50000 || this.record.payrollDeduction;

              let theBirthDate = this.record.birthDate;
              if (!!theBirthDate) {
                this.record.birthDate = moment(theBirthDate).format("YYYY-MM-DD");
              }
              let theSpouseBirthDate = this.record.spouseBirthDate;
              if (!!theSpouseBirthDate) {
                this.record.spouseBirthDate = moment(theSpouseBirthDate).format("YYYY-MM-DD");
              }
              console.log("[record]", this.record);
            })
            .catch((error) => {
              self.$set(self, "record", response.data);
              self.pastRecord = clone(response.data);
              let today = new Date();
              let orderCreatedDate = new Date(self.record.createdDate);
              let dateDifference = Math.round(today - orderCreatedDate);
              let weekDifference = Math.round(dateDifference / 1000 / 60 / 60 / 24 / 7);
              let weeksAllowedToChangeStatus = self.loggedInUser.orderStatus;
              let weeksAllowedToEdit = self.loggedInUser.editRecord;
              let weeksAllowedToRefund = self.loggedInUser.refundPayment;

              if (
                self.loggedInUser.userType == "admin" ||
                (self.loggedInUser.userType == "StandardUser" &&
                  weekDifference <= weeksAllowedToChangeStatus)
              ) {
                self.statusChangeAuth = true;
              }
              if (
                self.loggedInUser.userType == "admin" ||
                (self.loggedInUser.userType == "StandardUser" &&
                  weekDifference <= weeksAllowedToEdit)
              ) {
                self.editRecordAuth = true;
              }
              if (
                self.loggedInUser.userType == "admin" ||
                (self.loggedInUser.userType == "StandardUser" &&
                  weekDifference <= weeksAllowedToRefund)
              ) {
                self.voidRefundAuth = true;
              }
              this.disableButtons = false;
              this.form9465NotAllowed = this.record.totalDebt > 50000 || this.record.payrollDeduction;
              console.log("[record]", this.record);
            });
        })
        .catch((e) => {
          this.$router.push("/login");
          this.disableButtons = false;
        });
    },

    saveOrderDetails() {
      let self = this;
      this.disableButtons = true;
      if (this.record.product === "PaymentPlan") {
        this.$refs.paymentPlan.paymentPlan.secondaryPhone = this.record.secondaryPhone;
        this.$refs.paymentPlan.savePaymentPlan();
        if (!this.record.isCalifornia) {
          this.record.isOwedFromBusiness = this.$refs.paymentPlan.paymentPlan.isOwedFromBusiness;
          this.record.businessName = this.$refs.paymentPlan.paymentPlan.businessName;
          this.record.ein = this.$refs.paymentPlan.paymentPlan.ein;
          this.record.payrollDeduction = this.$refs.paymentPlan.paymentPlan.payrollDeduction;
        }
      } else {
        this.$refs.taxlienRemoval.saveTaxLien();
      }

      //if(this.manual_note.length > 0) {
      const isEmailUpdate = this.record.email !== this.pastRecord.email ? true : false;
      const isTrackingNumberUpdate =
        this.record.trackingNumber !== this.pastRecord.trackingNumber ? true : false;
      AXIOS.put(`/admin/order/id/${this.$route.params.id}/update`, {
        orderRecord: this.record,
        content: this.manual_note,
        trackingNumberContent: isTrackingNumberUpdate ? "TRACKING - EDITED" : "",
        emailChangeContent: isEmailUpdate ? "EMAIL - EDITED" : "",
        user: self.loggedInUser.username,
      })
        .then((response) => {
          self.addressesSaved = true;
          this.disableButtons = false;
          this.manual_note = "";
          if (
            response.data &&
            response.data.status === "Completed" &&
            response.data.trackingNumber &&
            response.data.trackingNumber !== null &&
            isTrackingNumberUpdate
          ) {
            this.emailNotificationModelData.title = "Notification Sending";
            this.emailNotificationModelData.content =
              "Would you like to send an email notification ?";
            this.$refs.emailNotificationModel.show();
          } else if (response.data.trackingNumber !== null && isTrackingNumberUpdate) {
            this.emailNotificationModelData.title = "Update Tracking Number";
            this.emailNotificationModelData.content =
              "Would you like to send an email notification to the customer?";
            this.$refs.emailNotificationModel.show();
          } else if (response.data.email != null && isEmailUpdate) {
            this.emailNotificationModelData.title = "Update Email Address";
            this.emailNotificationModelData.content =
              "Would you like to send an email notification to the customer?";
            this.$refs.emailNotificationModel.show();
          }
          this.pastRecord = response.data;
          self.onConfirmRefresh();
          this.isEditMode = false;
        })
        .catch((e) => {
          this.$router.push("/login");
          this.disableButtons = false;
        });
      //}
    },
    isChargeBackAvailable(status) {
      return (
        (this.disableButtons && !this.isEditMode) ||
        (status !== "Processing" && status !== "Completed")
      );
    },
    backToResults(isRoute) {
      if (isRoute === true) {
        this.$refs.backConfirmation.hide();
        this.$router.push("/admin/orders");
      } else if (isRoute == false) {
        this.$refs.backConfirmation.hide();
      } else if (this.isEditMode) {
        this.$refs.backConfirmation.show();
      } else {
        this.$refs.backConfirmation.hide();
        this.$router.push("/admin/orders");
      }
    },
    goToTracking() {
      if (this.record && this.record.trackingNumber)
        methods.uspsTracking(this.record.trackingNumber);
    },
  },
  mounted() {
    let userInStorage = JSON.parse(localStorage.getItem("loggedUser"));
    this.loggedInUser =
      this.$store.getters.getUser != ""
        ? this.$store.getters.getUser
        : userInStorage
        ? userInStorage
        : "";
    this.refresh();
  },
};
</script>
<style scoped>
.aside-item h2 {
  font-size: 3em;
}
.aside-item p {
  font-size: 1.5em;
}
.home-page {
  /* background-image: url(./../assets/banner.jpg); */
  background-size: cover;
}

table,
th,
td {
  border: 2px solid lightgrey;
  border-collapse: collapse;
}
th,
td {
  padding: 5px;
  text-align: left;
  width: 50%;
}

hr {
  border: 0;
  clear: both;
  display: block;
  width: 100%;
  background-color: lightgray;
  height: 1px;
}
.hide-br {
  display: none;
}

@media (min-width: 64em) {
  .hide-br {
    display: initial;
  }
}

.business-address label {
  font-weight: 700 !important;
  margin-top: 0.25rem !important;
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderDetails.vue